<template>
    <div>
        <PageTitle :title="'perfil SGA'" sectionClass="strech" />
        <section class="padding-vertical-content gray-content">
            <div class="container">
                <b-card>
                    <template #header>
                        <b-row>
                            <b-col cols="12">
                                <div class="d-flex justify-content-center align-items-center">
                                    <b-button variant="outline-primary p-1 p-md-3" @click="tab = 'datos'" :class="tab === 'datos' ? 'active' : ''">
                                        <i class="fa fa-id-card mr-1" aria-hidden="true"></i>{{ $t('perfil_sga.titulo_datos') }}
                                    </b-button>
                                    <b-button variant="outline-primary p-1 p-md-3" class="ml-3" @click="tab = 'abonos'" :class="tab === 'abonos' ? 'active' : ''">
                                        <i class="fa fa-address-book mr-1" aria-hidden="true"></i>{{ $t('perfil_sga.titulo_abonos') }}
                                    </b-button>
                                    <b-button variant="outline-primary p-1 p-md-3" class="ml-3" @click="tab = 'entradas'" :class="tab === 'entradas' ? 'active' : ''">
                                        <i class="fa fa-receipt mr-1" aria-hidden="true"></i>{{ $t('perfil_sga.titulo_entradas') }}
                                    </b-button>
                                </div>  
                            </b-col>
                        </b-row>                                              
                    </template>
                    <ContentOrLoading>
                        <template v-if="usuario">
                            <DatosCleComponent 
                                v-if="tab === 'datos'"
                                :usuario="usuario"
                                @updated="getPerfil"
                            />
                            <ListadoAbonosComponent v-if="tab === 'abonos'"/>
                            <ListadoEntradasComponent v-if="tab === 'entradas'"/>
                        </template>
                    </ContentOrLoading>                    
                </b-card>
            </div>
        </section>
    </div>
</template>

<script>
    import PageTitle from "@/components/frontend/shared/PageTitle";
    import DatosCleComponent from "./sga/DatosCleComponent.vue";
    import ListadoAbonosComponent from "./sga/ListadoAbonosComponent.vue";
    import ListadoEntradasComponent from "./sga/ListadoEntradasComponent .vue";

    export default {
        data() {
            return {
                teatro: this.$store.state.teatro,
                tab: 'datos',
                usuario: null
            };
        },
        mounted() {
            this.getPerfil();
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
        },
        methods: {
            getPerfil() {
                const data = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    tid : this.configuracion.hash_teatro
                }
            
                this.$store.dispatch(this.config.getVuexAlias('front.perfil.get'), data).then(res => {
                    this.usuario = res.data.datos;
                });
            }
        },
        components: {
            PageTitle, DatosCleComponent, ListadoAbonosComponent, ListadoEntradasComponent
        }
    };
</script>

